//
//
//
//
//
//


import { RELOAD_MAP_DATA_DURATION } from '~/config/settings/settingsTerminalScreen';

export default {
    async mounted() {
        await Promise.all([
            this.$store.dispatch('apidata/loadResortData'),
        ]);

        if (!this.$store.state.apidata.resortDataError) {
            this.$store.commit('apidata/setIsDataReady', true);
        } else {
            this.$store.commit('setFatalError', this.$t('errors.loading'));
            this.$bugsnag.notify(new Error(`Terminal Screen view: Error loading resort data: ${this.$store.state.apidata.resortDataError}`));
        }

        setInterval(() => {
            this.$store.dispatch('apidata/loadResortData');

            if (this.$store.state.apidata.resortDataError) {
                this.$bugsnag.notify(new Error(`Terminal Screen view: Error RE-loading resort data: ${this.$store.state.apidata.resortDataError}`));
            }
        }, RELOAD_MAP_DATA_DURATION);
    },
};
